<template>
  <the-section :title="$t('ec-line009.memberTitle')">
    <template #subTitle>
      <el-button class="section__button" @click="toEditingCustomerPage">
        {{ $t('common.action.edit') }}
      </el-button>
    </template>

    <el-row v-if="corporateFlag && data.business_account_flag" class="mt-5">
      <label class="text-body-01">{{ $t('common.memberInformation.companyName') }}</label>
      <p class="text-body-02 break-all">{{ data.company_name }}</p>
    </el-row>
    <el-row v-if="corporateFlag && data.store_name" class="mt-4">
      <label class="text-body-01">{{ $t('common.memberInformation.storeName') }}</label>
      <p class="text-body-02 break-all">{{ data.store_name }}</p>
    </el-row>
    <el-row :class="[data.business_account_flag ? 'mt-4' : 'mt-5']">
      <label class="text-body-01">{{ nameLabel }}</label>
      <p class="text-body-02 break-all">{{ full_name }}</p>
    </el-row>
    <el-row class="mt-4">
      <label class="text-body-01">{{ nameKanaLabel }}</label>
      <p class="text-body-02 break-all">{{ name_kana }}</p>
    </el-row>
    <el-row v-if="data.birth && !data.business_account_flag" class="mt-4">
      <label class="text-body-01">{{ $t('common.memberInformation.birthday') }}</label>
      <p class="text-body-02 break-all">{{ formattedBirthDate }}</p>
    </el-row>
    <el-row v-if="data.sex && !data.business_account_flag" class="mt-4">
      <label class="text-body-01">{{ $t('common.memberInformation.gender') }}</label>
      <p class="text-body-02 break-all">{{ data.sex && data.sex.name }}</p>
    </el-row>
    <el-row class="mt-4">
      <label class="text-body-01">{{ $t('common.memberInformation.email') }}</label>
      <p class="text-body-02 break-all">{{ data.email }}</p>
    </el-row>
    <el-row class="mt-4">
      <label class="text-body-01">{{ $t('common.memberInformation.address') }}</label>
      <p class="text-body-02 break-all">{{ full_address }}</p>
    </el-row>
    <el-row class="mt-4">
      <label class="text-body-01">{{ $t('common.memberInformation.phoneNumber') }}</label>
      <p class="text-body-02 break-all">{{ Utils.helper.getOnlyNumber(data.phone_number) }}</p>
    </el-row>
  </the-section>
</template>

<script>
import TheSection from '@/components/my-page-partials/TheSection.vue'
import { format } from 'date-fns'

export default {
  components: { TheSection },
  props: {
    data: { type: Object, default: () => {} },
    corporateFlag: { type: Boolean, default: false },
  },
  computed: {
    full_name() {
      return this.Utils.helper.fullName(this.data.name01, this.data.name02)
    },
    name_kana() {
      return this.Utils.helper.fullName(this.data.kana01, this.data.kana02)
    },
    full_address() {
      return this.Utils.helper.address(this.data.pref?.name, this.data.addr01, this.data.addr02, this.data.addr03)
    },
    formattedBirthDate() {
      return format(new Date(this.data.birth * 1000), 'yyyy/MM/dd')
    },
    nameLabel() {
      return this.corporateFlag
        ? this.$t('common.memberInformation.managerName')
        : this.data.business_account_flag
        ? this.$t('common.memberInformation.companyName')
        : this.$t('common.memberInformation.fullName')
    },
    nameKanaLabel() {
      return this.corporateFlag
        ? this.$t('common.memberInformation.managerKana')
        : this.data.business_account_flag
        ? this.$t('common.memberInformation.companyNameKana')
        : this.$t('common.memberInformation.nameKana')
    },
  },
  methods: {
    toEditingCustomerPage() {
      this.$router.push(this.$routePage.EC_LINE010)
    },
  },
}
</script>
<style lang="scss" scoped>
label.required {
  &::after {
    content: '※';
  }
}
</style>
